import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailTellentLogoComponent } from '../../components/email-tellent-logo/email-tellent-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { TellentProductsFooterComponent } from '../../components/tellent-products-footer/tellent-products-footer.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  styleUrls: ['../../global-styles.less', './tellent-account-deleted.component.less'],
  templateUrl: './tellent-account-deleted.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailLinkComponent,
    EmailTellentLogoComponent,
    TellentProductsFooterComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class TellentAccountDeletedTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<TellentAccountDeletedTemplateData>;
}

export type TellentAccountDeletedTemplateData = {
  header: string;
  subheader: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
};

export const TellentAccountDeletedTemplateMocks: TellentAccountDeletedTemplateData[] = [
  {
    header: 'Account deletion confrmation',
    subheader: 'Your account has been permanently deleted along with all associated data.',
    footer: {
      text: 'Need help?',
      href: 'https://auth.tellent.com/?intercom_open=true',
      label: 'Contact us',
      target: '_blank',
    },
  },
];
